import { render, staticRenderFns } from "./BusinessList.vue?vue&type=template&id=2e1349b3&scoped=true"
import script from "./BusinessList.vue?vue&type=script&lang=js"
export * from "./BusinessList.vue?vue&type=script&lang=js"
import style0 from "./BusinessList.vue?vue&type=style&index=0&id=2e1349b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1349b3",
  null
  
)

export default component.exports